import { CommonModule, JsonPipe } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { AuthService } from '../../../shared/services/common/auth.service';
import { UserModel } from '../../../shared/models/apis/system/user/user.model';
import { AuthHospitalModel } from '../../../shared/models/common/auth-hospital.model';

import { TimeagoModule } from 'ngx-timeago';

@Component({
  selector: 'app-home',
  templateUrl: 'home.component.html',
  standalone: true,
  imports: [TimeagoModule,JsonPipe, CommonModule],
})
export class HomeComponent implements OnInit {
   private readonly _authService = inject(AuthService);
    currentUser = signal<UserModel|null>(null);
    currentSelectedHospital = signal<AuthHospitalModel|null>(null);

  ngOnInit(): void {
    this._authService.getCurrentUser().then(authData => {
        this.currentUser.set(authData);

        this.currentSelectedHospital.set(this._authService.getCurrentSelectedHospital());
    });

    this._authService.defaultHospitalObservable.subscribe(defaultHospital => {
        this.currentSelectedHospital.set(defaultHospital);
    })
  }

}
